import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faMoneyBillWave,
  faExchangeAlt,
  faHandHoldingUsd,
  faBalanceScale,
} from '@fortawesome/free-solid-svg-icons';

const formatAmount = (value) =>
  value != null && !isNaN(value) ? parseFloat(value).toFixed(2) : '0.00';

const SummaryCard = ({ title, value, icon, footer, valuePrefix = '' }) => (
  <div className="summary-tile">
    <div className="d-flex align-items-start justify-content-between gap-2 mb-2">
      <div className="label">{title}</div>
      <span className="summary-tile-icon">
        <FontAwesomeIcon icon={icon} />
      </span>
    </div>
    <div className="value money-figure">
      {valuePrefix}£{formatAmount(value)}
    </div>
    {footer && <div className="small text-muted mt-2">{footer}</div>}
  </div>
);

const DashboardSummary = ({ summary }) => {
  const net = summary.netBalance ?? (summary.owedToYou || 0) - (summary.youOwe || 0);

  return (
    <div className="balance-strip">
      <SummaryCard
        title="You owe"
        value={summary.youOwe || 0}
        icon={faHandHoldingUsd}
        footer="Remaining reclaim"
      />
      <SummaryCard
        title="Owed to you"
        value={summary.owedToYou || 0}
        icon={faBalanceScale}
        footer={
          summary.partner?.displayName
            ? `From ${summary.partner.displayName}`
            : 'Partner reclaim'
        }
      />
      <SummaryCard
        title="Net position"
        value={Math.abs(net)}
        icon={faExchangeAlt}
        valuePrefix={net >= 0 ? '+' : '−'}
        footer={net >= 0 ? 'In your favour' : 'You are behind'}
      />
      <SummaryCard
        title="Total spent"
        value={summary.totalExpenses}
        icon={faMoneyBillWave}
        footer="All recorded expenses"
      />
    </div>
  );
};

export default DashboardSummary;
